import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Form, Field} from 'react-final-form';
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import {classNames} from "primereact/utils";
import {addLocale} from "primereact/api";
import {InputSwitch} from "primereact/inputswitch";
import {Dropdown} from "primereact/dropdown";
import {TreeSelect} from "primereact/treeselect";
import axios from "axios";

const CostcenterFormComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [newFormData, setNewFormData] = useState({});
  const [profitCenters, setProfitCenters] = useState([]);
  const [costCenterTree, setCostCenterTree] = useState([]);

  const findCostCenterNode = (nodes, key) => {
    for (const node of nodes || []) {
      if (String(node.key) === String(key)) return node;
      const found = findCostCenterNode(node.children, key);
      if (found) return found;
    }
    return null;
  };

  const selectableParentTree = (nodes) => (nodes || []).reduce((result, node) => {
    const currentId = formData?.id ?? id ?? window.App.urlVars().costcenterId;
    if (currentId && String(node.key) === String(currentId)) return result;
    result.push({...node, children: selectableParentTree(node.children)});
    return result;
  }, []);

  const validate = (data) => {
    let errors = {};
    // if (!data.company) {
    //   errors.company = 'Kötelező mező';
    // }
    // if (!data.partner) {
    //   errors.partner = 'Kötelező mező';
    // }
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    if ((window.App.urlVars().costcenterId) || (entity === 'cost-center' && id)) {
      apiCall('patch', '/api/v2/cost-center/' + (window.App.urlVars().costcenterId ?? id), newFormData)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderCostcenterList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    } else {
      apiCall('post', '/api/v2/cost-center', newFormData)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderCostcenterList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          } else {
            history.push('/finance/cost-center/update/' + response.data.data.id);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }
  // const toolbarOptions = {
  //   container: [
  //     [{'header': [1, 2, 3, 4, 5, 6, false]}],
  //     ['bold', 'italic', 'underline', 'strike'],
  //     ['image', 'formula'],
  //     [{'align': []}],

  //     [{'list': 'ordered'}, {'list': 'bullet'}, {'list': 'check'}],
  //     [{'script': 'sub'}, {'script': 'super'}],
  //     [{'indent': '-1'}, {'indent': '+1'}],
  //     [{'color': []}, {'background': []}],
  //     ['clean']
  //   ]
  // }

  useEffect(() => {
    if ((!window.App.urlVars().create && window.App.urlVars().costcenterId) || (entity === 'cost-center' && id)) {
      setLoading(true);
      apiCall('get', '/api/v2/cost-center/' + (window.App.urlVars().costcenterId ?? id))
        .then(response => {
          setFormData(response.data.data)
          setNewFormData(response.data.data)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  }, [])

  useEffect(() => {
    apiCall('get', '/api/v2/profit-center/tree')
      .then(res => setProfitCenters(res.data.data.items || []))
      .catch(error => window.App.toastShow('error', t('error'), error.toString(), '', error.response));
    apiCall('get', '/api/v2/cost-center/tree')
      .then(res => setCostCenterTree(res.data?.data?.items || []))
      .catch(error => window.App.toastShow('error', t('error'), error.toString(), '', error.response));
    if ((!window.App.urlVars().create && window.App.urlVars().costcenterId) || (entity === 'cost-center' && id)) {
      setLoading(true);
      apiCall('get', '/api/v2/cost-center/' + (window.App.urlVars().costcenterId ?? id))
        .then(response => {
          setFormData(response.data.data)
          setNewFormData(response.data.data)
        })
        .catch(error => window.App.toastShow('error', t('error'), error.toString(), '', error.response))
        .finally(() => setLoading(false));
    }
  }, [])

  return (
    <div className={"costcenter-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <Form onSubmit={onSubmit} initialValues={formData}
            validate={validate} render={({handleSubmit, submitting}) => (
        <form onSubmit={handleSubmit} className="">
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-8"}>
              <Field name="name" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="name"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldName')}</label>
                  <span className="p-d-block">
                      <InputText id="name" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     name: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     name: e.target.value
                                   })
                                 }}
                                 value={formData.name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
              
            </div>
            <div className={"p-col-12 p-lg-4"}>
              <Field name="code" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="code"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldIdentifier')}</label>
                  <span className="p-d-block">
                      <InputText id="code" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     code: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     code: e.target.value
                                   })
                                 }}
                                 value={formData.code}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-4"}>
              <Field name="parent" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="parent"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{t('fieldParentCostCenter')}</label>
                  <TreeSelect
                    id="parent"
                    value={formData?.parent?.id ? String(formData.parent.id) : (formData?.parent ? String(formData.parent) : null)}
                    options={selectableParentTree(costCenterTree)}
                    filter
                    showClear
                    placeholder={t('selectParentCostCenterPlaceholder')}
                    emptyMessage={t('noCostCenterYet')}
                    appendTo={document.body}
                    onChange={(e) => {
                      const parent = e.value ? Number(e.value) : null;
                      const parentNode = parent ? findCostCenterNode(costCenterTree, parent) : null;
                      const profitCenter = parentNode?.data?.profit_center?.id ?? formData?.profit_center?.id ?? formData?.profit_center ?? null;
                      setFormData({...formData, parent, profit_center: profitCenter});
                      setNewFormData({...newFormData, parent, profit_center: profitCenter});
                    }}
                  />
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-12"}>
              <Field name="active" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="active"
                          className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldActive')}</label>
                  <span className="p-d-block">
                        <InputSwitch
                          className={"p-mt-1"}
                          checked={!!formData.active}
                          value={formData.active}
                          onChange={e => {
                            setFormData({...formData, active: e.value});
                            setNewFormData({...newFormData, active: e.value});
                          }}/>
                      </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-4"}>
              <Field name="profit_center" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="profit_center"
                          className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldProfitCenter')}</label>
                  <TreeSelect
                    id="profit_center"
                    value={(formData?.profit_center?.id ?? formData?.profit_center) ? String(formData?.profit_center?.id ?? formData?.profit_center) : null}
                    options={profitCenters}
                    selectionMode="single" filter
                    placeholder={t('selectBusinessUnitPlaceholder')}appendTo={document.body}
                    onChange={(e) => {
                      setFormData({...formData, profit_center: e.value ? Number(e.value) : null});
                      setNewFormData({...newFormData, profit_center: e.value ? Number(e.value) : null});
                    }}
                  />
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>

            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>
              {entity === 'cost-center' &&
                <Button type="submit" label={t('save')}
                        loading={loading}
                        icon={"pi pi-save"}
                        className="p-button-success p-ml-2"/>
              }
              <Button type="submit" label={t('saveAndBack')}
                      onClick={() => {
                        props = {...props, goback: true}
                      }}
                      loading={loading}
                      icon={"pi pi-arrow-left"}
                      className="p-button-success p-ml-2"/>
            </div>
          </div>
        </form>
      )}/>
    </div>
  )
}
export default withTranslation('common')(CostcenterFormComponent);
